
interface FAQ {
  id: string;
  question: string;
  views: number;
}

interface FAQSidebarProps {
  popularFaqs: FAQ[];
  onSelectFaq: (id: string) => void;
}

export default function FAQSidebar({ popularFaqs, onSelectFaq }: FAQSidebarProps) {
  return (
    <div className="space-y-6">
      {/* Perguntas Populares */}
      <div className="bg-white rounded-xl border border-neutral-200 p-6 shadow-soft">
        <h3 className="text-lg font-semibold text-neutral-800 mb-4 flex items-center">
          <i className="ri-fire-line text-secondary mr-2"></i>
          Mais Populares
        </h3>
        <ul className="space-y-3">
          {popularFaqs.map((faq, index) => (
            <li key={faq.id}>
              <button
                onClick={() => onSelectFaq(faq.id)}
                className="w-full text-left group cursor-pointer"
              >
                <div className="flex items-start space-x-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary/10 text-primary text-xs font-bold rounded-full">
                    {index + 1}
                  </span>
                  <span className="text-sm text-neutral-600 group-hover:text-primary transition-colors line-clamp-2">
                    {faq.question}
                  </span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* CTA WhatsApp */}
      <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
        <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4">
          <i className="ri-whatsapp-line text-2xl"></i>
        </div>
        <h3 className="text-lg font-semibold mb-2">Não encontrou sua resposta?</h3>
        <p className="text-sm text-green-100 mb-4">
          Fale diretamente com nossa equipe pelo WhatsApp. Estamos prontos para ajudar!
        </p>
        <a
          href="https://wa.me/5511999999999?text=Olá,%20tenho%20uma%20dúvida%20sobre%20o%20TG%20WEB"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center space-x-2 px-4 py-2.5 bg-white text-green-600 font-semibold rounded-lg hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-chat-1-line"></i>
          <span>Iniciar Conversa</span>
        </a>
      </div>

      {/* CTA Demonstração */}
      <div className="bg-gradient-to-br from-primary to-primary-700 rounded-xl p-6 text-white">
        <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4">
          <i className="ri-play-circle-line text-2xl"></i>
        </div>
        <h3 className="text-lg font-semibold mb-2">Quer ver na prática?</h3>
        <p className="text-sm text-primary-100 mb-4">
          Agende uma demonstração gratuita e veja como o TG WEB pode transformar sua transportadora.
        </p>
        <a
          href="https://wa.me/5511999999999?text=Olá,%20gostaria%20de%20agendar%20uma%20demonstração%20do%20TG%20WEB"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center space-x-2 px-4 py-2.5 bg-secondary text-white font-semibold rounded-lg hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-calendar-line"></i>
          <span>Agendar Demo</span>
        </a>
      </div>
    </div>
  );
}
